import type { ReactNode } from 'react'
import type { Chain, Transport } from 'viem'
import { http } from 'viem'
import { WagmiProvider, createConfig } from 'wagmi'
import { hardhat } from 'wagmi/chains'
import { injected, walletConnect } from 'wagmi/connectors'
import { ENV } from '@/config/env'
import { ACTIVE_CHAINS, testnetChain } from '@/config/chains'

const metadata = {
    name: 'Blockpot Operator Console',
    description: 'Operator back-office for Blockpot',
    url: typeof window !== 'undefined' ? window.location.origin : 'https://blockpot.com',
    icons: [],
}

// Every chain is http-only and polls at 4 s, matching the service event
// stream's poll. Live "something changed" signals come from that stream
// (src/lib/eventStream.ts), so no transport needs a websocket.
const POLLING_INTERVAL_MS = 4_000

function buildTransport(chain: Chain): Transport {
    if (chain.id === hardhat.id) return http('http://localhost:8545')
    if (chain.id === testnetChain.id) return http(testnetChain.rpcUrls.default.http[0])
    return http()
}

const transports = Object.fromEntries(ACTIVE_CHAINS.map((c) => [c.id, buildTransport(c)] as const))

const connectors = ENV.WALLETCONNECT_PROJECT_ID
    ? [
          walletConnect({ projectId: ENV.WALLETCONNECT_PROJECT_ID, metadata, showQrModal: true }),
          injected({ shimDisconnect: true }),
      ]
    : [injected({ shimDisconnect: true })]

const wagmiConfig = createConfig({
    chains: ACTIVE_CHAINS as unknown as readonly [
        (typeof ACTIVE_CHAINS)[number],
        ...(typeof ACTIVE_CHAINS)[number][],
    ],
    transports,
    connectors,
    pollingInterval: POLLING_INTERVAL_MS,
})

export default function Web3Provider({ children }: { children: ReactNode }) {
    return <WagmiProvider config={wagmiConfig}>{children}</WagmiProvider>
}
